<script setup>
import { onMounted, watch } from 'vue'

import { useRouter } from 'vue-router'
const router = useRouter()

import { useRoute } from 'vue-router'
const route = useRoute()

const isWechatEnv = () => /MicroMessenger/i.test(navigator.userAgent)

const hideAllShareMenu = () => {
  // 先判断对象是否已经存在
  if (typeof window.WeixinJSBridge === "undefined") {
    // 不存在时监听微信专属的就绪事件，等注入完成后再执行逻辑
    document.addEventListener('WeixinJSBridgeReady', () => {
      window.WeixinJSBridge?.call('hideOptionMenu')
    }, false)
  } else {
    // 已经注入完成直接调用
    window.WeixinJSBridge?.call('hideOptionMenu')
  }
}

onMounted(() => {
  if (isWechatEnv()) hideAllShareMenu()
})

// 监听路由变化，单页应用跳转后重新执行禁用逻辑
watch(() => route.path, () => {
  if (isWechatEnv()) hideAllShareMenu()
})

// 基础跳转
const goToAbout = () => {
  // 直接传入路径字符串
  // router.push('/about')
  // 也支持对象写法，可搭配传参
  router.push({ path: '/', query: { id: 456} })
}
</script>

<template>
  <div>
    <button @click="goToAbout()">admin</button>
    AdminIndex  禁用分享
  </div>
</template>

<style scoped>

</style>